/* ==========================================================================
   GroundLuxe — Review & Rating Enhancements (behavior)
   - Makes the buy-box rating badge scroll to the review list.
   - Injects a designed, on-brand heading above the Loox review list.
   - Pulls the real average + count from Loox when available; falls back to
     evergreen copy (never fabricates a number).
   Defensive: no-ops cleanly if elements are missing or load late.
   ========================================================================== */
(function () {
  'use strict';

  var REVIEWS_SECTION = '#shopify-section-loox-product-reviews-app-section';
  var BADGE_SELECTORS = '.loox-rating, .rating, .rating-count';

  function reviewsSection() {
    return document.querySelector(REVIEWS_SECTION);
  }

  function scrollToReviews() {
    var target = reviewsSection();
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ---- 1) Click the rating badge -> jump to reviews ---------------------- */
  function wireBadgeClick() {
    document.addEventListener('click', function (e) {
      var inBuyBox = e.target.closest('[id^="MainProduct"]');
      if (!inBuyBox) return;
      var badge = e.target.closest(BADGE_SELECTORS);
      if (!badge) return;
      e.preventDefault();
      scrollToReviews();
    });

    // Add affordance class to the badge once it exists (it may load async).
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      var badges = document.querySelectorAll('[id^="MainProduct"] ' + BADGE_SELECTORS.split(', ').join(', [id^="MainProduct"] '));
      if (badges.length) {
        badges.forEach(function (b) {
          b.classList.add('gl-rating-link');
          b.setAttribute('role', 'link');
          b.setAttribute('tabindex', '0');
          b.setAttribute('aria-label', 'Read customer reviews');
        });
        clearInterval(iv);
      }
      if (tries > 40) clearInterval(iv); // ~12s safety stop
    }, 300);
  }

  /* ---- 2) Read real rating data from Loox (when present) ----------------- */
  function readLooxData() {
    var el = document.querySelector('.loox-rating[data-rating], .loox-rating[data-raters]');
    if (!el) return null;
    var rating = parseFloat(el.getAttribute('data-rating'));
    var count = parseInt(el.getAttribute('data-raters') || el.getAttribute('data-count'), 10);
    return {
      rating: isNaN(rating) ? null : rating,
      count: isNaN(count) ? null : count
    };
  }

  function starsFor(rating) {
    var full = Math.round((rating || 5) * 2) / 2; // nearest half
    var out = '';
    for (var i = 1; i <= 5; i++) {
      if (full >= i) out += '\u2605';            // ★ full
      else if (full >= i - 0.5) out += '\u2605'; // treat half as full for display row
      else out += '\u2606';                       // ☆ empty
    }
    return out;
  }

  /* ---- 3) Inject the designed heading above the review list -------------- */
  function buildHeading(data) {
    var wrap = document.createElement('div');
    wrap.className = 'gl-reviews-heading';

    var kicker = document.createElement('p');
    kicker.className = 'gl-reviews-kicker';
    kicker.textContent = 'Real customer reviews';
    wrap.appendChild(kicker);

    var stars = document.createElement('div');
    stars.className = 'gl-reviews-stars';
    stars.setAttribute('aria-hidden', 'true');
    stars.textContent = starsFor(data && data.rating);
    wrap.appendChild(stars);

    if (data && data.rating != null && data.count != null) {
      var score = document.createElement('p');
      score.className = 'gl-reviews-score';
      score.innerHTML =
        '<b>' + data.rating.toFixed(1) + ' out of 5</b>' +
        '<span>from ' + data.count.toLocaleString() + ' verified reviews</span>';
      wrap.appendChild(score);
    }

    var title = document.createElement('h2');
    title.className = 'gl-reviews-title';
    title.textContent = 'Loved by better sleepers';
    wrap.appendChild(title);

    var sub = document.createElement('p');
    sub.className = 'gl-reviews-sub';
    sub.textContent = 'Real photos and stories from people who swapped restless nights for grounded ones. Read what changed for them \u2193';
    wrap.appendChild(sub);

    var hr = document.createElement('hr');
    hr.className = 'gl-reviews-divider';
    wrap.appendChild(hr);

    return wrap;
  }

  function injectHeading() {
    var section = reviewsSection();
    if (!section || section.querySelector('.gl-reviews-heading')) return;
    section.id = section.id; // keep Shopify id
    section.insertAdjacentElement('afterbegin', buildHeading(readLooxData()));

    // If Loox numbers arrive after injection, fill them in.
    if (!readLooxData()) {
      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        var d = readLooxData();
        var heading = section.querySelector('.gl-reviews-heading');
        if (d && heading && d.rating != null && d.count != null) {
          var starsEl = heading.querySelector('.gl-reviews-stars');
          if (starsEl) starsEl.textContent = starsFor(d.rating);
          if (!heading.querySelector('.gl-reviews-score')) {
            var score = document.createElement('p');
            score.className = 'gl-reviews-score';
            score.innerHTML =
              '<b>' + d.rating.toFixed(1) + ' out of 5</b>' +
              '<span>from ' + d.count.toLocaleString() + ' verified reviews</span>';
            starsEl.insertAdjacentElement('afterend', score);
          }
          clearInterval(iv);
        }
        if (tries > 40) clearInterval(iv);
      }, 300);
    }
  }

  function init() {
    wireBadgeClick();
    injectHeading();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
